import * as React from 'react';
type Props = {
  className?: string;
};
export function Information({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Information"
      className={className}
    >
      <circle cx={12} cy={12} r={8} stroke="currentColor" strokeWidth={2} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 1a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1Z"
        fill="currentColor"
      />
    </svg>
  );
}
